import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

var firebaseConfig = {
    apiKey: "AIzaSyBglMemahr7V71bDMNzhSyceFzrRI4K5xo",
    authDomain: "book-tracker-323606.firebaseapp.com",
    projectId: "book-tracker-323606",
    // storageBucket: "book-tracker-323606.appspot.com",
    // messagingSenderId: "340960480884",
    appId: "1:340960480884:web:d75d7ba115b606f79e8b21",
    // measurementId: "G-RMK17RG9ND"
  };
  // Initialize Firebase
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  export const db = firebaseApp.firestore()
  export const auth = firebase.auth()

 